module.exports = __webpack_public_path__ + "img/monoid-light.34aa7546.png";